import React, { useState } from "react";
import { NotificationManager, NotificationContainer } from "react-notifications";

const TextAreaFse = ({ value, setValue }) => {
    const [testo, setTesto] = useState(value);

    const handleSubmit = () => {
        NotificationManager.listNotify.forEach(n => NotificationManager.remove({ id: n.id }));
        if (!testo.trim()) {
            NotificationManager.warning("Il campo è obbligatorio", "Attenzione");
            return;
        }
        NotificationManager.success("Salvataggio avvenuto con successo", "Salva");
        setValue(testo);
    };

    const handleCancella = () => {
        setValue("");
        setTesto("");
    }

    return (
        <div className="container mt-4">
            <div className="mb-3">
                <textarea
                    className="form-control"
                    rows="4"
                    value={testo}
                    onChange={(e) => setTesto(e.target.value)}
                ></textarea>
            </div>
            <div className="d-flex justify-content-between">
                <button className="btn btn-primary" onClick={handleSubmit}>
                    Conferma
                </button>
                <button type="button" className="btn btn-danger text-white" onClick={handleCancella}>
                    Cancella
                </button>
            </div>
            <NotificationContainer />
        </div>
    );
};

export default TextAreaFse;
